function qs(selector, scope) {
  return (scope || document).querySelector(selector);
}

function qsArray (selector, scope) {
  var nodeList = (scope || document).querySelectorAll(selector);
  var arr = [];
  for(var i = 0; i < nodeList.length; i++) {
    arr.push(nodeList[i]);
  }
  return arr;
}

export { qs, qsArray };
